import React from 'react';
import { Button as CrateButton } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionReport.css';

export type RegionReportFooterProps = {
  disabledSave?: boolean;
  onCancelClick: () => void;
  onDeleteClick?: () => void;
  saveClick?: () => void;
  showSaveButton: boolean;
};

export const RegionReportFooter = ({
  onCancelClick,
  onDeleteClick,
  saveClick = () => undefined,
  disabledSave,
  showSaveButton,
}: RegionReportFooterProps) => (
  <div className={styles.modalFooter} data-test-id="frr-enhanced-ui-footer">
    <div>
      <CrateButton
        className={styles.cancelRegionReportButton}
        data-test-id="frr-footer-cancel-button"
        mode="secondary"
        onClick={onCancelClick}
      >
        {getMessage('cancel')}
      </CrateButton>
    </div>
    {!showSaveButton && (
      <div>
        <CrateButton
          data-test-id="frr-footer-delete-button"
          mode="primary"
          onClick={onDeleteClick}
        >
          {getMessage('regions.report.modal.delete.report')}
        </CrateButton>
      </div>
    )}
    {showSaveButton && (
      <div>
        <CrateButton
          className={styles.saveRegionReportButton}
          data-test-id="frr-footer-save-button"
          disabled={disabledSave}
          mode="primary"
          onClick={saveClick}
        >
          {getMessage('regions.report.modal.saveReport')}
        </CrateButton>
      </div>
    )}
  </div>
);
